import React from "react";
import { DialogActions } from "material-ui-next/Dialog";
import { StyledButton } from "components/support";

const Actions = ({ closeModal, handleSaveButtonClick, editing }) => (
  <DialogActions style={{ padding: 24, margin: 0 }}>
    <StyledButton flat onClick={closeModal}>
      Cancelar
    </StyledButton>
    <StyledButton primary onClick={handleSaveButtonClick}>
      {!editing ? "Salvar" : "Atualizar"}
    </StyledButton>
  </DialogActions>
);

export default Actions;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/dialog/DialogActions/DialogActions.jsx